import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import './InputNumber-7d93e963.js';
import { Link } from './components/shared/Link.es.js';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import '@teko-builder/types/pb';
import { b as textAnchorCss } from './text-21866551.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import { getStyle } from './utils.es.js';
import styled from '@emotion/styled';

const StyledParagraph = styled.div(({ commonStyle }) => `
    ${getStyle(commonStyle)};
    & ul, & ol {
      margin-left: 1rem;
    }
  `, textAnchorCss);

const Paragraph = (_a) => {
    var { text, link, enabled = false } = _a, rest = __rest(_a, ["text", "link", "enabled"]);
    const paragraph = (jsx(StyledParagraph, Object.assign({}, rest, { dangerouslySetInnerHTML: { __html: text } })));
    if (!enabled)
        return jsx(Link, Object.assign({}, link, { children: paragraph }));
    return paragraph;
};
Paragraph.displayName = 'Paragraph';

export { Paragraph as P, StyledParagraph as S };
